// `getPreviousEngagementText` (extension-alert-client-contacts.component.ng1.ts:2146) — the
// "Prev. engagement" line on a contact row.
//
// ⚠️ IT IS NOT "LEVEL, THEN COUNT". Three known levels are rewritten into a phrase that drops
// the level's wording entirely — "Had placements" with a count of 2 reads "2 placements" — and
// each pluralises differently: `placement`/`placements`, `hiring process`/`hiring processes`,
// `open job`/`open jobs`. Anything else falls back to `Level (count)`.
//
// Rendering the level alone, which is what this file replaces, showed "Had placements" where
// production shows "2 placements": the right words for the wrong screen, and no number at all.

export interface PreviousEngagement {
  contactHighestActivityLevel?: string | null
  contactHighestActivityCount?: number | null
}

/** Whether the block renders at all — BOTH truthy, and the count is 0 for most contacts. */
export function hasPreviousEngagement(ats: PreviousEngagement | null | undefined): boolean {
  if (ats === null || ats === undefined) return false
  const { contactHighestActivityLevel: level, contactHighestActivityCount: count } = ats
  return typeof level === 'string' && level.length > 0 && typeof count === 'number' && count > 0
}

export function previousEngagementText(ats: PreviousEngagement): string {
  const level = ats.contactHighestActivityLevel ?? ''
  const count = ats.contactHighestActivityCount ?? 0
  // `count > 1`, so a count of 0 would read as singular — which the guard above prevents from
  // ever rendering, and which is upstream's own comparison.
  const plural = count > 1

  switch (level) {
    case 'Had placements':
      return `${String(count)} placement${plural ? 's' : ''}`
    case 'Had hiring processes':
      return `${String(count)} hiring process${plural ? 'es' : ''}`
    case 'Had open jobs':
      return `${String(count)} open job${plural ? 's' : ''}`
    default:
      return `${level} (${String(count)})`
  }
}
